import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';
import { components } from 'react-select';

import './styles/DropdownIndicator.css';

const { DropdownIndicator: RSDropdownIndicator } = components;

const DropdownArrow = props => (
  <RSDropdownIndicator {...props}>
    {props.selectProps.menuIsOpen ? (
      <Glyphicon glyph="triangle-top" />
    ) : (
      <Glyphicon glyph="triangle-bottom" />
    )}
  </RSDropdownIndicator>
);

DropdownArrow.propTypes = {
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool
  }).isRequired
};

export default DropdownArrow;
